export default {
	methods: {
		async load() {
			if(!this.url) {
				if(typeof(this.setSeo) !== 'undefined') {
					this.setSeo();
				}
				return;
			}
			this.$store.state.loading++;
			try {
				const data = await this.$get(this.url);
				this.$set(this.$store.state, 'pageData', data);
				if(typeof(this.setSeo) !== 'undefined') {
					this.setSeo();
				}
			} catch(e) {
				this.$store.state.notFound = e.code === 404;
			}
			this.$store.state.loading--;
		}
	},
	async serverPrefetch() {
		await this.load();
		this.$store.state.serverFetched = true;
	},
	async mounted() {
		if(this.$store.state.serverFetched) {
			this.$store.state.serverFetched = false;
			return;
		}
		await this.load();
	},
	computed: {
		notFound() {
			return this.$store.state.notFound;
		}
	}
};